export default __webpack_public_path__ + "static/box-2-8e04bf4949b3063c3eddd7a922046233.webp";